<script setup lang="ts">
interface Props {
  companyName: string
  overviewText?: string
}

const props = defineProps<Props>()

const defaultOverview = `${props.companyName} policy varies by role. Most clerks and part-timers report no testing, while warehouse staff and drivers may be tested.`
</script>

<template>
  <p class="text-lg text-slate-700 mb-6">
    {{ overviewText || defaultOverview }}
  </p>
</template>
